import '../css/style.css'

export default function Content() {

    const photoSetup = [
        {
            name: 'Condensate auto drain SXD 3',
            link: 'https://dwb.com.pl/wp-content/uploads/2023/02/Condensate-auto-drain-SXD-3-scaled-e1675337317236.jpg'
        },
        {
            name: 'Cover diffusor 3CI, 4CI  3283E6 1, 67506576 Ingersoll Rand',
            link: 'https://dwb.com.pl/wp-content/uploads/2023/02/Cover-diffusor-3CI-4CI-3283E6-1-67506576-Ingersoll-Rand-kopia-—-kopia.jpg'
        },
        {
            name: 'Diffuser C700 – 3X11567-1',
            link: 'https://dwb.com.pl/wp-content/uploads/2023/02/Diffuser-C700-–-3X11567-1-scaled.jpg'
        },
        {
            name: 'Heater unit for SXD',
            link: 'https://dwb.com.pl/wp-content/uploads/2023/02/Heater-unit-for-SXD-scaled.jpg'
        },
        {
            name: 'Oil cooler 3.503.298-9 42958371 Ingersoll Rand',
            link: 'https://dwb.com.pl/wp-content/uploads/2023/02/Oil-cooler-3.503.298-9-42958371-Ingersoll-Rand-scaled.jpg'
        },
        {
            name: 'Oil heater 3461SP, 94876018 Ingersoll Rand',
            link: 'https://dwb.com.pl/wp-content/uploads/2023/02/Oil-heater-3461SP-94876018-Ingersoll-Rand-scaled.jpg'
        },
        {
            name: 'Plain bearing 5x15186 67942003 Ingersoll Rand',
            link: 'https://dwb.com.pl/wp-content/uploads/2023/02/Plain-bearing-5x15186-67942003-Ingersoll-Rand-scaled.jpg'
        },
        {
            name: 'Plain bearing 5x15187 67942052 Ingersoll Rand',
            link: 'https://dwb.com.pl/wp-content/uploads/2023/02/Plain-bearing-5x15187-67942052-Ingersoll-Rand-scaled.jpg'
        },
        {
            name: 'Thrust bearing 5X15188 67942011 Ingersoll Rand',
            link: 'https://dwb.com.pl/wp-content/uploads/2023/02/Thrust-bearing-5X15188-67942011-Ingersoll-Rand-scaled.jpg'
        },
        {
            name: 'Transition piece 2CI - 5X855 67535013 Ingersoll Rand',
            link: 'https://dwb.com.pl/wp-content/uploads/2023/02/Transition-piece-2CI-5X855-67535013-Ingersoll-Rand-scaled.jpg'
        }
    ]

    return(
        <div className='content'>
            <div className='container'>
            { photoSetup.map(selections => {
                    return(
                        <div className="selection">
                            <a href={ selections.link } target="_blank" rel="noreferrer">
                                <img src={ selections.link } alt={ selections.name } height="250" width="250" className="photos"/>
                                <div className='selection-down'>
                                    <div>{ selections.name }</div>
                                </div>
                            </a>
                        </div>
                    )
            }) }
            </div>
        </div>
    )
}